/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { RefObject, useEffect } from 'react';
import { Platform } from 'react-native';

interface UseOutsideClickOptions {
  enabled?: boolean;
}

export const useOutsideClick = <T>(
  ref: RefObject<T | null>,
  onOutsideClick: () => void,
  { enabled = true }: UseOutsideClickOptions = {},
) => {
  useEffect(() => {
    if (!enabled || Platform.OS !== 'web' || typeof document === 'undefined')
      return;

    const handlePointerDown = (event: PointerEvent) => {
      const node = ref.current as unknown as Node | null;

      if (node?.contains(event.target as Node)) return;

      onOutsideClick();
    };

    document.addEventListener('pointerdown', handlePointerDown, true);

    return () => {
      document.removeEventListener('pointerdown', handlePointerDown, true);
    };
  }, [enabled, onOutsideClick, ref]);
};
